export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7953.df8ef4d8.jpg";